import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Alert, Box, Stack, Typography } from '@mui/material';

import HiddenApprovedFooter from '../../reportCards/HiddenApprovedFooter';
import ReportCard from '../../reportCards/ReportCard';
import type { ManualOverrideState } from '../../types';

import DealCard from './DealCard';
import type { DealOptionsInclusionsDealRow } from './types';

interface Props {
  dealRows: Array<DealOptionsInclusionsDealRow>;
  expandedRows: Record<string, boolean>;
  hiddenApprovedCount: number;
  manualOverrides: ManualOverrideState;
  showAutoApproved: boolean;
  onApprovalChange: (rowId: string) => void;
  onToggleDetails: (rowId: string, defaultOpen?: boolean) => void;
  onUnapprovalChange: (rowId: string) => void;
}

export default function DealOptionsInclusionsReportCard({
  dealRows,
  expandedRows,
  hiddenApprovedCount,
  manualOverrides,
  showAutoApproved,
  onApprovalChange,
  onToggleDetails,
  onUnapprovalChange,
}: Props) {
  return (
    <ReportCard bordered={false}>
      <Stack spacing={2} sx={{ pb: 2 }}>
        <Alert severity="info" icon={<InfoOutlinedIcon fontSize="small" />}>
          <strong>RRP comparison:</strong> the dot is{' '}
          <Box component="span" sx={{ color: 'success.main', fontWeight: 700 }}>
            green
          </Box>{' '}
          when <strong>Inclusion Asset Value</strong> exactly equals <strong>Deal Option Inclusion RRP</strong>. It
          turns{' '}
          <Box component="span" sx={{ color: 'warning.main', fontWeight: 700 }}>
            orange
          </Box>{' '}
          when those values differ.
        </Alert>

        {dealRows.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ p: 1 }}>
            No deal options found.
          </Typography>
        ) : (
          dealRows.map((deal) => (
            <DealCard
              key={deal.id}
              deal={deal}
              expandedRows={expandedRows}
              manualOverrides={manualOverrides}
              showAutoApproved={showAutoApproved}
              onApprovalChange={onApprovalChange}
              onToggleDetails={onToggleDetails}
              onUnapprovalChange={onUnapprovalChange}
            />
          ))
        )}
      </Stack>

      <HiddenApprovedFooter count={hiddenApprovedCount} noun="inclusion row" showAutoApproved={showAutoApproved} />
    </ReportCard>
  );
}
